import customFetch from '../utils/fetch';
import { API_ENDPOINTS } from '../constants/api-endpoint';

// 郵便番号から住所を検索する
const search = async (zipcode) => {
  try {
    return await customFetch(API_ENDPOINTS.POSTAL_CODE(zipcode), {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    });
  } catch (error) {
    console.error('郵便番号検索エラー:', error);
    throw error;
  }
};

export const postalService = {
  search
};
